import { logUsage } from 'owa-analytics';
import { ListViewBitFlagsMasks, setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { FeedbackCategory, FeedbackDialogParams, FeedbackRibbon } from 'owa-feedback';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import loc from 'owa-localize';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { onSpotlightDisabled } from 'owa-mail-spotlight-options';
import { getUserConfiguration, lazyUpdateUserConfigurationService } from 'owa-session-store';
import * as React from 'react';
import {
    spotlightDisableAfterFeedbackButtonMessage,
    spotlightDisableAfterFeedbackThankYouMessage,
    spotlightFeedbackCategory1,
    spotlightFeedbackCategory2,
    spotlightFeedbackCategory3,
    spotlightFeedbackCategory4,
    spotlightFeedbackCategory5,
    spotlightFeedbackDialogSubtitle,
    spotlightFeedbackDialogTitle,
    spotlightFeedbackDonationText,
    spotlightFeedbackInputPlaceholderText,
    spotlightFeedbackRibbonMessage,
    spotlightMoreFeedbackRibbonMessage,
} from './getFeedbackRibbonForSpotlightFeedbackInfoBar.locstring.json';

const styles = require('./getFeedbackRibbonForNudgeInfoBar.scss');

export default function getFeedbackRibbonForSpotlightFeedbackInfoBar(
    itemViewState: ItemViewState,
    key: string,
    donationJson: string,
    feedbackMetadata: string
): JSX.Element {
    const removeInfoBar = () => {
        removeInfoBarMessage(itemViewState, key);
    };

    const doNotWantSpotlightOption = 'Option #1';

    // Show feedback ribbon in the notification bar
    const feedbackCategories: FeedbackCategory[] = [
        {
            logString: doNotWantSpotlightOption,
            uiString: loc(spotlightFeedbackCategory1),
        },
        {
            logString: 'Option #2',
            uiString: loc(spotlightFeedbackCategory2),
        },
        {
            logString: 'Option #3',
            uiString: loc(spotlightFeedbackCategory3),
        },
        {
            logString: 'Option #4',
            uiString: loc(spotlightFeedbackCategory4),
        },
        {
            logString: 'Option #5',
            uiString: loc(spotlightFeedbackCategory5),
        },
    ];

    const shouldShowCustomThankYouMessage = (
        inlineFeedbackResponseSelectedCategories: string[]
    ): boolean => {
        return inlineFeedbackResponseSelectedCategories.includes(doNotWantSpotlightOption);
    };

    const onActionButtonOnThankyouClicked = () => {
        // Disable Spotlight setting
        setBit(true, ListViewBitFlagsMasks.SpotlightDisabled);
        lazyUpdateUserConfigurationService.importAndExecute(
            [
                {
                    key: 'ListViewBitFlags',
                    valuetype: 'Integer32',
                    value: [`${getUserConfiguration().ViewStateConfiguration?.ListViewBitFlags}`],
                },
            ],
            'OWA.ViewStateConfiguration'
        );

        // Clear Spotlight items in the store
        onSpotlightDisabled();

        logUsage('Spotlight_DisabledViaFeedback');
    };

    const feedbackDialogParams: FeedbackDialogParams = {
        title: loc(spotlightFeedbackDialogTitle),
        subTitle: loc(spotlightFeedbackDialogSubtitle),
        categories: feedbackCategories,
        ghostText: loc(spotlightFeedbackInputPlaceholderText),
        donationText: loc(spotlightFeedbackDonationText),
        donationJson: donationJson,
        thankYouDialogParams: {
            actionButtonMessage: loc(spotlightDisableAfterFeedbackButtonMessage),
            thankYouMessage: loc(spotlightDisableAfterFeedbackThankYouMessage),
            onActionButtonClick: onActionButtonOnThankyouClicked,
            shouldShowCustomThankYouMessage: shouldShowCustomThankYouMessage,
        },
    };

    return (
        <div className={styles.spotlightFeedbackRibbon}>
            <FeedbackRibbon
                feature="Spotlight"
                subFeature="Spotlight"
                ribbonMessage={loc(spotlightFeedbackRibbonMessage)}
                moreFeedbackRibbonMessage={loc(spotlightMoreFeedbackRibbonMessage)}
                okCallBack={removeInfoBar}
                notNowCallBack={removeInfoBar}
                noFeedbackDialogParams={feedbackDialogParams}
                hideRibbonIconDiv={true}
                metadata={feedbackMetadata}
            />
        </div>
    );
}
